/** @format */

import {useEffect, useRef, useState} from 'react';

import {Trans} from 'react-i18next';

import {ArrowOutwardOutlined} from '@mui/icons-material';

import {useTheme} from '@mui/material/styles';

import {format} from 'date-fns';

import {ru} from 'date-fns/locale';

import {useNavigate} from 'react-router-dom';

import ModalPage from 'components/ModalPage';

import {ROUTES} from 'constants/ROUTES';

import {DownloadLink} from './components/DownloadLink';
import {
  Root,
  OtherReportButton,
  InfoBox,
  ProjectAndDate,
  Project,
  StyledDate,
  FormatBox,
  TextHeading,
  TextRegular,
} from './styles';
import {MAX_PROJECT_BOX_WIDTH} from './constants';
import {useGetCurrentUserQuery} from './graphql/__generated__';

const Report = () => {
  const [isColumn, setIsColumn] = useState<boolean>(false);

  const theme = useTheme();
  const projectRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const node = projectRef.current;
    if (!node) return;

    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        const isOverflowing = entry.target.clientWidth > MAX_PROJECT_BOX_WIDTH;
        setIsColumn(isOverflowing);
      }
    });

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, []);

  const {loading, error, data} = useGetCurrentUserQuery();
  if (loading || error || !data?.currentUser?.currentCompany) {
    return null;
  }

  const handleReports = () => {
    navigate(`/home/main/${ROUTES.MAIN_REPORTS}`);
  };

  const lastCheckCollectDate = data.currentUser.currentCompany.lastCheckCollectDate;

  const formattedDate = lastCheckCollectDate
    ? format(lastCheckCollectDate, 'dd MMMM yyyy', {locale: ru})
    : '';

  return (
    <Root data-testid='report-root'>
      <ModalPage header={<Trans>Скачать отчёт</Trans>}>
        <InfoBox>
          <ProjectAndDate isColumn={isColumn}>
            <Project ref={projectRef}>
              <TextHeading>Проект</TextHeading>
              <TextRegular data-testid='report-project-name'>
                {data.currentUser.currentCompany.name}
              </TextRegular>
            </Project>
            <StyledDate>
              <TextHeading>Дата</TextHeading>
              <TextRegular data-testid='report-date'>{formattedDate}</TextRegular>
            </StyledDate>
          </ProjectAndDate>
          <OtherReportButton onClick={handleReports} data-testid='report-button-more'>
            <ArrowOutwardOutlined sx={{fontSize: '16px', marginRight: theme.spacing(2)}} />
            <Trans>Отчёты за другие даты</Trans>
          </OtherReportButton>
        </InfoBox>

        <FormatBox>
          <DownloadLink fileFormat='pdf' share={false} data={data} />
          <DownloadLink fileFormat='xlsx' share data={data} />
          <DownloadLink fileFormat='html' share data={data} />
        </FormatBox>
      </ModalPage>
    </Root>
  );
};

export default Report;
